import React, {useState} from "react";
import SingleFilterWrap from "../SingleFilterWrap/SingleFilterWrap";
import PriceRange from "../PriceRange/PriceRange";

const SideBarFilter = ({ setSideBarFilter }) => {
  const info = [
    {
      title: "NFT Categories",
      filterOption: [
        { title: "Tier 1", checked: false, label: "tier1" },
        { title: "Tier 2", checked: false, label: "tier2" },
      ],
    },
    {
      title: "Tokens Vested",
      filterOption: [
        { title: "Drip", checked: true, label: "drip" },
        { title: "BR34P", checked: false, label: "br34p" },
        { title: "ACQ", checked: false, label: "acq" },
      ],
    },
    {
      title: "Currencies",
      filterOption: [
        { title: "ETH", checked: true, label: "eth" },
        { title: "R34P", checked: false, label: "arb" },
        { title: "USDT", checked: true, label: "eth" },
        { title: "ARB", checked: false, label: "arb" },
        { title: "ETH", checked: true, label: "eth" },
        { title: "WBTC", checked: false, label: "arb" },
      ],
    },
    {
      title: "Auction Type",
      filterOption: [
        { title: "Buyout", checked: true, label: "eth" },
        { title: "Bid Auctions", checked: false, label: "arb" },
      ],
    },
  ];
  return (
    <div>
      <div className="flex items-center justify-between border-b border-[#3C3C56] px-[40px] pb-[16px] pt-[16px]">
        <h2 className="text-res-sm font-bold md:leading-[26px]">Filter</h2>
        <button className="text-res-xxs font-bold text-main-green">
          Reset
        </button>
      </div>
      <div className="px-[40px]">
        {info.map((single, i) => (
          <SingleFilterWrap
            setSideBarFilter={setSideBarFilter}
            key={i}
            {...single}
          ></SingleFilterWrap>
        ))}

        <div className="pt-[48px] pb-[89px]">
          <h2 className="text-res-ls pb-[16px] font-bold">Price Range</h2>
          <PriceRange
            defaultMin={800}
            defaultMax={1850}
            min={0}
            max={3000}
          ></PriceRange>
        </div>
      </div>
    </div>
  );
};

export default SideBarFilter;
